const initState = {
  subtopics: [],
};

const resultHalCompassReducer = (state = initState, action) => {
  switch (action.type) {
    case "ADDED_RESULT_HALCOMPASS":
      return {
        ...state,
        addResultHalCompassSuccess: {
          message: action.message,
          type: "addResultHalCompassSuccess",
          id: action.id,
        },
      };
    case "ADDED_RESULT_HALCOMPASS_ERROR":
      return {
        ...state,
        addResultHalCompassError: {
          message: action.err.message,
          type: "addResultHalCompassError",
        },
      };
      
    default:
      return state;
  }
};

export default resultHalCompassReducer;
